export const STAFF_ROLES = ["admin", "ops_admin", "super_admin"];
export const isStaff = (user) => STAFF_ROLES.includes(user?.role);
export const isSuperAdmin = (user) => user?.role === "super_admin";
export const isReadOnlyAdmin = (user) => user?.role === "admin";
export const isOpsAdmin = (user) => user?.role === "ops_admin";
// super_admin or ops_admin: may run day-to-day outreach (dialer, batches, daily sends, campaign emails, lead edits).
export const canOperate = (user) => user?.role === "super_admin" || user?.role === "ops_admin";
